import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FullTable, NoItemsYet, SearchHistory } from 'components';
import { historyActions } from 'store';
import { historyBody, historyHead, historyNotYet } from './constants';
import { FindLoad } from 'utils';

const ACTION_TYPE = 'GET_HISTORY';
export const HistoryTab = ({ onModel, currentId, height, notYet, noHistoryYet, noPagination, saveParams }) => {
    const dispatch = useDispatch();
    const historyList = useSelector((state) => state.history.history);
    const navigate = useNavigate();
    const location = useLocation();
    const [filters, setFilters] = useState({
        skip: 0,
    });
    const info = saveParams ? filters : location?.state;
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        const params = {
            ...info,
        };
        delete params.page;
        delete params.activeTab;
        delete params.from;
        params.skip = info?.skip ? info?.skip : 0;
        if (noPagination) {
            delete params.limit;
        } else {
            params.limit = 50;
        }
        dispatch(historyActions.getHistory(onModel, { onResource: currentId, ...params }));
    }, [info]);

    if (noHistoryYet && !historyList?.histories?.length && !loader?.length) {
        return (
            <NoItemsYet
                height={noHistoryYet?.height}
                text={noHistoryYet.title}
                subTitle={noHistoryYet.subTitle}
                image={noHistoryYet.image}
            />
        );
    }

    return (
        <div>
            <div className="header-action-btn" style={{ justifyContent: 'flex-start' }}>
                <SearchHistory />
            </div>
            <FullTable
                savedParams={saveParams ? filters : null}
                getParams={saveParams ? (e) => setFilters(e) : null}
                head={historyHead}
                body={historyBody}
                loadingType={ACTION_TYPE}
                list={historyList?.histories}
                listCount={noPagination ? [] : historyList?.count}
                notYet={notYet === 'notShow' ? null : historyNotYet}
                noText={notYet === 'notShow' ? 'History' : ''}
                activeRowId={''}
                margin={'0'}
                height={height}
            />
        </div>
    );
};
